// @flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import theme from './NotesList.scss';
import ListWithHeader from 'common/components/core/list/ListWithHeader';
import { ButtonTypes, ButtonWithPopover } from 'common/components/core/button';
import { PopoverTriggerEnum } from 'common/components/core/popover/popOverFactory';
import { dashboardColors } from 'common/enums/ColorEnum';
import { List as ImmutableList } from 'immutable';
import { PlanNote } from 'common/components/core/table/PlanNote';
import { tableButtonWithPopoverFactory } from 'common/components/common/TableButtonWithPopover';
type Props = {
    list: Array<Object>,
    listTitle: string,
    theme: Object,
    t: Function,
    preferPlace: string,
    accessor: string,
    defaultAddButton: boolean,
    original: Object,
    addNewNote: boolean,
    onListClose: Function,
    editDisabled?: boolean,
    deleteDisabled?: boolean,
    addButtonPopover?: React.Node,
    saveButtonPopover?: React.Node,
    deleteButtonPopover?: React.Node
};

class NotesList extends React.PureComponent<Props> {
    constructor(props) {
        super(props);
        let defaultNotes = [];
        if (props.list && props.list.size) {
            defaultNotes = props.list.toJS();
        }
        if (props.addNewNote) {
            defaultNotes = [...defaultNotes, ''];
        }
        this.state = {
            notes: defaultNotes
        };
    }

    addNewNote = () => {
        const { notes } = this.state;
        this.setState({
            notes: [...notes, '']
        });
    };

    deleteNote = noteIndex => {
        const { notes } = this.state;
        const updatedNotes = notes.filter((note, index) => {
            if (index !== noteIndex) {
                return note;
            }
        });
        this.setState({
            notes: updatedNotes
        });
    };

    saveAllNotes = () => {
        const { notes } = this.state;
        const { accessor, original, updateNotes } = this.props;
        const updatedNotes = ImmutableList(notes.map(note => note));
        return updateNotes && updateNotes(original, updatedNotes, accessor);
    };

    saveNote = (value, noteIndex) => {
        if (value === null) {
            return this.deleteNote(noteIndex);
        }
        const { notes } = this.state;
        const updatedNotes = notes.map((note, index) => {
            if (index === noteIndex) {
                return value;
            }
            return note;
        });
        this.setState({
            notes: updatedNotes
        });
    };

    render() {
        const {
            theme,
            t,
            onListClose,
            editDisabled,
            deleteDisabled,
            addButtonPopover,
            saveButtonPopover,
            deleteButtonPopover
        } = this.props;
        const { notes } = this.state;
        return (
            <ListWithHeader
                onListClose={onListClose}
                theme={theme}
                title={t('pjpTable.notes')}
                isListEditable
            >
                {notes.map((note, index) => {
                    return (
                        <PlanNote
                            t={t}
                            index={index}
                            note={note}
                            theme={theme}
                            key={index}
                            saveNote={this.saveNote}
                            deleteNote={this.deleteNote}
                            editDisabled={editDisabled}
                            deleteDisabled={deleteDisabled}
                            deleteButtonPopover={deleteButtonPopover}
                        />
                    );
                })}
                <div className={theme.notesButtons}>
                    <ButtonWithPopover
                        color={dashboardColors.darkSkyBlue.name}
                        buttonType={ButtonTypes.Text}
                        theme={theme}
                        onClick={this.addNewNote}
                        disabled={editDisabled}
                        popOverContent={addButtonPopover}
                        triggerPopoverOn={PopoverTriggerEnum.Hover}
                    >
                        {t('add')}
                    </ButtonWithPopover>
                    <ButtonWithPopover
                        color={dashboardColors.darkSkyBlue.name}
                        uppercase
                        buttonType={ButtonTypes.Solid}
                        theme={theme}
                        onClick={this.saveAllNotes}
                        disabled={editDisabled}
                        popOverContent={saveButtonPopover}
                        triggerPopoverOn={PopoverTriggerEnum.Hover}
                    >
                        {t('save')}
                    </ButtonWithPopover>
                </div>
            </ListWithHeader>
        );
    }
}

export const NotesButtonWithPopover = tableButtonWithPopoverFactory({
    ListElement: NotesList
});

export default compose(
    themr('NotesList', theme),
    translate('entityManagement')
)(NotesButtonWithPopover);
